<template>
    <tr :model="vo" colspan="10">
        <td class="el-table__cell tdcont tdw83" colspan="10">
            <el-select v-model="vo.meetingClassily" :disabled="edit" :placeholder="$tx('hygl.components.inputMeetingType', '请输入会议类型')" @change="selectTwo">
                <el-option v-for="item in tempList" :key="item.value" :label="item.value" :value="item.value" />
            </el-select>
        </td>
    </tr>
</template>

<script>
import Bus from '../bus.js'
export default {
    name: 'SelectTwo',
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            status: '',
            edit: false,
            tempList: '',
            options: [
                {
                    value: '选项1',
                    label: this.$tx('hygl.components.meetingTypeOptinLabel1', '院领导班子会议和院党委会议'),
                    version: [
                        {
                            key: 1,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson1', '院领导班子会议')
                        },
                        {
                            key: 2,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson2', '院党委会议')
                        }
                    ]
                },
                {
                    value: '选项2',
                    label: this.$tx('hygl.components.meetingTypeOptinLabel2', '以院名义举办的会议'),
                    version: [
                        {
                            key: 1,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson3', '院属单位（部门）主要负责同志参加')
                        },
                        {
                            key: 2,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson4', '院属单位（部门）负责同志参加')
                        },
                        {
                            key: 3,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson5', '院外单位和人员参加')
                        }
                    ]
                },
                {
                    value: '选项3',
                    label: this.$tx('hygl.components.meetingTypeOptinLabel3', '机关部门召集的会议'),
                    version: [
                        {
                            key: 1,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson6', '院属单位业务部门参加')
                        }
                    ]
                },
                {
                    value: '选项4',
                    label: this.$tx('hygl.components.meetingTypeOptinLabel4'),
                    version: [
                        {
                            key: 1,
                            value: this.$tx('hygl.components.meetingTypeOptinVerson7', '国际会议')
                        }
                    ]
                }
            ]
        }
    },
    created() {
        const _this = this
        // 用$on监听事件并接受数据
        Bus.$on('send', (data) => {
            _this.tempList = data
        })
        Bus.$on('status', (data) => {
            _this.status = data
        })
    },
    mounted() {
        this.getStatus()
    },
    methods: {
        selectTwo(params) {
            this.vo.meetingClassily = params
            console.log(this.vo.meetingClassily)
        },
        getStatus() {
            if (this.vo.status === -1 || this.vo.status === 0) {
                this.edit = false
                $('.el-input__inner').css('border', 'block')
                $('.el-input__inner').css('backgroundColor', '#fff')
                $('.el-select__caret').css('color', '#ccc')
            } else if (this.vo.status === 1) {
                this.edit = false
                $('.el-input__inner').css('border', 'none')
                $('.el-input__inner').css('backgroundColor', '#fff')
                $('.el-select__caret').css('color', '#fff')
            } else {
                this.edit = true
                $('.el-input__inner').css('border', 'none')
                $('.el-input__inner').css('backgroundColor', '#fff')
                $('.el-select__caret').css('color', '#fff')
            }
        }
    }
}
</script>

<style scoped>
.el-table .tdcont {
    border: none;
}
.el-select {
    width: 100%;
}
.el-select-dropdown__list {
    display: flex;
    flex-direction: column;
}
</style>
